import styled from 'styled-components';

export const Container = styled.div`
  width: 100px;
  height: 100%;
`;

export const ItemGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const StaticLabel = styled.div`
  color: ${(props) => props.theme.simulation.staticTextColor};
  margin-bottom: 15px;
`;

export const DynamicLabel = styled.div`
  --fs: 1.0rem;
  --lh: 1.4rem;
  margin-top: 15px;
  font-size: var(--fs);
  line-height: var(--lh);
  display: block;
  max-width: 120px;
  max-height: 38px;
  text-align: center;
  color: ${(props) => props.theme.simulation.dynamicTextColor};
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
`;

export const Items = styled.div`
  display: flex;
  align-items: center;
`;

export const Item = styled.div`
  padding: 0 10px;
`;
